import type { Visibility } from "../api/types";
import { VISIBILITY_LABELS } from "../lib/format";

/**
 * Marks an item that is not public — "Private", "Members", or "Shared". Public
 * items get nothing, so anonymous visitors never see a badge at all; members
 * and the admin (who are shown non-public items) can always tell which ones
 * the rest of the world cannot see.
 */
export function VisibilityBadge({ visibility }: { visibility: Visibility | null | undefined }) {
  if (!visibility || visibility === "PUBLIC") return null;
  return (
    <span className="vis-badge" data-vis={visibility} title={TITLES[visibility]}>
      {VISIBILITY_LABELS[visibility]}
    </span>
  );
}

const TITLES: Record<Visibility, string> = {
  PUBLIC: "Visible to everyone",
  MEMBERS: "Visible to signed-in members only",
  RESTRICTED: "Shared with specific members only",
  PRIVATE: "Private — only the site owner can see this",
};
